/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Manage_Storage_Schedule_BtnInputs */



/**
* | output |
* | --- |
* | "Schedule change" |
*
* @param {Partner_Manage_Storage_Schedule_BtnInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_manage_storage_schedule_btn = /** @type {((inputs?: Partner_Manage_Storage_Schedule_BtnInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Manage_Storage_Schedule_BtnInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Änderung planen")
	return /** @type {LocalizedString} */ ("Schedule change")
});